
import { Link } from 'react-router-dom';

export default function Services() {
  const services = [
    {
      icon: 'ri-car-line',
      title: 'Auto Insurance',
      description: 'Comprehensive coverage for your vehicle with competitive rates and excellent customer service.',
      features: ['Collision Coverage', 'Comprehensive Coverage', '24/7 Roadside Assistance', 'Rental Car Coverage'],
      quoteLink: '/auto-quote'
    },
    {
      icon: 'ri-home-4-line',
      title: 'Home Insurance',
      description: 'Protect your most valuable asset with our comprehensive homeowners insurance policies.',
      features: ['Property Protection', 'Personal Liability', 'Additional Living Expenses', 'Personal Property Coverage']
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'Life Insurance',
      description: 'Secure your family\'s financial future with our flexible life insurance solutions.',
      features: ['Term Life Insurance', 'Whole Life Insurance', 'Universal Life Insurance', 'Final Expense Insurance']
    },
    {
      icon: 'ri-briefcase-line',
      title: 'Business Insurance',
      description: 'Comprehensive protection for your business operations and commercial assets.',
      features: ['General Liability', 'Property Insurance', 'Workers Compensation', 'Professional Liability']
    },
    {
      icon: 'ri-hospital-line',
      title: 'Health Insurance',
      description: 'Quality healthcare coverage options to keep you and your family healthy.',
      features: ['Individual Plans', 'Family Coverage', 'Dental & Vision', 'Medicare Supplements']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Specialty Insurance',
      description: 'Specialized coverage for unique situations and specific protection needs.',
      features: ['Umbrella Insurance', 'Motorcycle Insurance', 'Boat Insurance', 'Travel Insurance']
    }
  ];

  return (
    <section className="py-20 bg-white/95 backdrop-blur-sm" id="services">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in-up opacity-0">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Our Insurance Treatments
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Just like a medical practice, we offer specialized treatments for all your insurance needs. Each policy is carefully prescribed to provide optimal protection.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white/90 backdrop-blur-sm rounded-xl shadow-lg p-8 hover:shadow-2xl transition-all duration-500 hover:scale-105 group animate-fade-in-up opacity-0 border border-white/20"
              style={{ animationDelay: `${(index + 1) * 200}ms` }}
            >
              <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors duration-300">
                <i className={`${service.icon} text-3xl text-blue-600 group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-700 hover:text-blue-600 transition-colors duration-200">
                    <i className="ri-check-line text-blue-600 mr-3 text-lg"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
              {service.quoteLink ? (
                <Link 
                  to={service.quoteLink}
                  className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer block text-center"
                >
                  Get Quote
                </Link>
              ) : (
                <button className="mt-6 w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-semibold transition-all duration-300 hover:shadow-lg whitespace-nowrap cursor-pointer">
                  Get Quote
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-16 animate-fade-in-up opacity-0" style={{ animationDelay: '1400ms' }}>
          <div className="bg-blue-600/95 backdrop-blur-sm rounded-2xl p-8 text-white border border-blue-400/20">
            <h3 className="text-3xl font-bold mb-4">Need a Custom Treatment Plan?</h3>
            <p className="text-xl mb-6 text-blue-100">
              Our insurance doctors can create a personalized coverage prescription just for you.
            </p>
            <button className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer">
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
